import HttpRequest from './http_request'
import { getStoreBearer, getUnitID } from '@/utils/helper/localStorage'
import moment from 'moment'

class ReportProvider extends HttpRequest {
  constructor () {
    super(process.env.SELLSUKI_URL)
  }

  async getReportZ (date) {
    this.setHeader({
      'Authorization': await getStoreBearer()
    })
    const {data: {results}} = await this.get('/pos/report-z', {
      date,
      pos_unit_id: getUnitID()
    })

    if (results.last_bill.length !== 0) {
      results.last_bill[0].create_time = moment(results.last_bill[0].create_time).add(7, 'hours').format('DD-MM-YYYY HH:mm')
    }
    if (results.first_bill.length !== 0) {
      results.first_bill[0].create_time = moment(results.first_bill[0].create_time).add(7, 'hours').format('DD-MM-YYYY HH:mm')
    }
    return results
  }
}

export default ReportProvider



// WEBPACK FOOTER //
// ./src/resources/report_provider.js